<template>
  <div class="invitation-fbid-check-container">
    <div class="header">
      <ul>
        <li>
          <div class="sub-view list-view columb main-center">
            <div class="list-view-title"><strong>{{detailData.projectName}}</strong></div>
            <div class="list-view-info row">                                  
              <div class="list-view-info-area"><img class="icon" src="@/assets/img/weizhi.svg" alt=""><span>位置定位</span></div>
              <div class="list-view-info-type"><img class="icon" src="@/assets/img/lingdang.svg" alt=""><span>{{noticePublicity}}</span></div>
              <div class="list-view-info-time"><img class="icon" src="@/assets/img/shijian1.svg" alt=""><span>{{detailData.releaseTime}}</span></div>
            </div>
            <!-- {{detailData.tendererAddress || '&nbsp;'}} -->
          </div>
        </li>
      </ul>
    </div>
    <div class="banner cf">
      <span>能源一号网&nbsp;&nbsp;随时随地查看机遇的公众号</span>
      <span class="btn" @click="show1 = true"><img class="icon" src="@/assets/img/fxzf.svg" alt="">分享公告</span>
    </div>
    <div v-if="noticeType != '3' && noticeType != '4'">
      <p class="project-content" v-html='detailData.bulletinContent'></p>
    </div>
    <div v-else>
      <p class="project-content" v-html='detailSpe.content'></p>
    </div>
    <van-overlay :show="show1" @click="show1 = false">
      <div class="wrapper" @click.stop>
        <img src="@/assets/img/grayBox.png" width="100%" alt="">
        <div class="know" @click="show1 = !show1"></div>
      </div>
    </van-overlay>
    <div v-if="files!=null && files.length > 0">
      <nail-menu
              :id="id"
              :fileName="fileName"
              :files ='files'
              @downLoadFile="downLoadFile"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import nailMenu from '@/components/NailMenu'
import {
  Toast, Overlay
} from 'vant';

export default {
  components: {
    [Overlay.name]: Overlay,
    nailMenu
  },
     name: "SubscribeDetails",
  data() {
    return {
      detailData: {
        // 具体详情内容
        bulletinContent: '',
        clicks: '',
        noticeNumber: '',
        noticeType: '',
        projectName: '',
        // 更新时间
        releaseTime: '',
        // 所在地
        tendererAddress: ''
      },
      detailSpe: {
        content: ''
      },
      show: false,
      show1: false,
      id:'',
      fileName: '',
      files:[],
      shareCode: '',
      option: [
        { text: '新增准入招标公告', value: "1" },
        { text: '新增准入招标结果公示', value: "2" },
        { text: '新增准入结果公示', value: "3" },
      ],
      noticeTypeMsg:'',
      baseURL: process.env.VUE_APP_BASE_URL + '/'
    };
  },

  computed: {
    noticeNumber() {
      // 接收router传参  大概是detail详情的id
      //return this.$route.params.noticeNumber
      return this.$route.query.noticeNumber
      
    },
    noticeType() {
      // 接收router传参
      //return this.$route.params.noticeType
      return this.$route.query.noticeType
    },
    noticePublicity(){
      return  this.$route.query.noticeType == 1 ? "新增准入招标公告" : (this.$route.query.noticeType == 2 ? "新增准入招标结果公示" : "新增准入结果公示" )
      
    }
  },
  mounted(){
    this.getDetail();
    
  },
  methods: {
    // getPushInfoed(){
    //   const param = {
    //         noticeNumber:this.$route.query.noticeNumber,
    //         noticeType:this.$route.query.noticeNumber,
            
    //      }
    //     //  console.log(this.$route.query.page,'dsfsdadsfas')
    //    api.workOrder.getPushInfo(param).then((res)=>{
    //      if(res.code == 0){
           
    //      }
    //    })
    // },
    async wxInit(){
      let that = this
      this.option.forEach(item => {
        
          this.noticeTypeMsg = item.text
        
      })
      let sendUrl = window.location.href;
      var u = navigator.userAgent;
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isiOS){
        sendUrl = this.baseURL + 'index'
      }
      let res = await api.home.getWxSignData({url:sendUrl})
      // console.log(res)
      if(res.data){
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp+'', // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature,// 必填，签名
          jsApiList: ['updateAppMessageShareData','updateTimelineShareData','chooseImage','showMenuItems','hideOptionMenu'] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          wx.showMenuItems({
            menuList: [
              "menuItem:share:appMessage",//发送给朋友
              'menuItem:share:timeline', // 分享到朋友圈
            ]
          });
          //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
          wx.updateAppMessageShareData({
            title: '给您分享一个' + that.noticeTypeMsg,//that.detailData.projectName, // 分享标题
            desc: that.detailData.projectName, // 分享描述
            link: that.baseURL + 'share?shareCode=' + that.shareCode, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.baseURL + require('@/assets/img/logo.png'), // 分享图标
            success: function () {
              that.markShareCode("1")
            }
          })
          //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
          wx.updateTimelineShareData({
            title: that.detailData.projectName, // 分享标题
            link: that.baseURL + 'share?shareCode=' + that.shareCode, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.baseURL + require('@/assets/img/logo.png'), // 分享图标
            success: function () {
              that.markShareCode("2")
            }
          })
        });
      }
    },
    async markShareCode(type){
      const param = {
        shareCode: decodeURIComponent(this.shareCode),
        type: type
      }
      let res = await api.invitationFBid.markShareCode(param);
      if(res.msg === "success"){
        //Toast("分享成功")
      }
    },
    downLoadFile(item) {
     
      this.$router.push({
        name: 'enclosure',
        params: {
          item: item,
          noticeNumber: this.noticeNumber,
          noticeType: this.noticeType,
      
        }
      })
    },
    showActions(obj) {
      this.show = obj;
    },
    onSelect(item) {
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.show = false;
      Toast(item.name);
    },
    // 获取详情内容数据
    async getDetail() {
      const param = {
        noticeNumber: this.noticeNumber,
        noticeType: this.noticeType
      }
      const res = await api.notice.addContractorNoticeView(param);
      const { data } = res;
      if(data.attachmentDtos && data.attachmentDtos.length>0){
        this.id = data.attachmentDtos[0].id;
        this.fileName = data.attachmentDtos[0].fileName;
      }
      this.files = data.attachmentDtos;
      if(this.noticeType == '3'){
        this.detailSpe.content = this.createTable(data.candidateDtos);
      }else if(this.noticeType == '4'){
        this.detailSpe.content = this.createTable(data.finaldetailDtos);
      }
      this.detailData = data;
      this.getShareCode()
    },
    //生成分享code
    async getShareCode() {
      const param = {
        noticeNumber: this.noticeNumber,
        noticeType: this.noticeType
      }
      const res = await api.invitationFBid.getShareCode(param);
      if (res.msg === 'success') {
        this.shareCode = encodeURIComponent(res.data);
        this.wxInit();
        // console.log("http://xinqidian.vicp.io:18110/share?shareCode=" + this.shareCode);
        // console.log("获取后台shareCode："+res.data);
        // console.log("encode放入链接shareCode："+this.shareCode);
      }
    },
    createTable(list) {
      let html = "";
      html = "<table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"dataground\" align=\"center\">\n" +
              "    <tbody><tr>\n" +
              "        <td align=\"center\">\n" +
              "            <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"table_st\" width=\"930px\" height=\"150px\">\n" +
              "                <colgroup span=\"2\" align=\"left\">\n" +
              "                    <col align=\"right\">\n" +
              "                    <col>\n" +
              "                </colgroup>\n" +
              "                <tbody>\n" +
              "                <tr>\n" +
              "                    <td width=\"9%\" class=\"col\">招标投标项目名称:</td>\n" +
              "                    <td width=\"80%\" class=\"col1\">";
      html += list[0].projectname + "</td>\n" +
              "                </tr>";
      html += "<tr>\n" +
              "                    <td class=\"col\">招标人：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].projectcorporationname){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].projectcorporationname + "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">招标代理机构：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].tenderagencyname){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].tenderagencyname+ "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">开标日期：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].opentenderdate){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].opentenderdate + "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">评标时间：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].evaluateTenderDate){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].evaluateTenderDate + "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">\n" +
              "                        评标结果：\n" +
              "                    </td>\n" +
              "                    <td>\n";
      if(!list[0].resultcontent || list[0].resultcontent == '0003' ){//投标人排名、报价及分数
        html += "                        <table id=\"bidtable\" border=\"1\" width=\"600px\" cellspacing=\"0\" cellpadding=\"0\" style=\"'border:1x solid #e0e0e0;'\">\n" +
                "                            <tbody><tr>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">投标人</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">标段</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">标段报价(元)</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">技术分</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">商务分</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">价格分</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">评标总分</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">排名</td>\n" +
                "                                <td align=\"center\" style=\"white-space:nowrap\">备注</td>\n" +
                "                            </tr>";
        for(var i = 0; i < list.length; i++){
          html += "<tr align=\"center\">";
          if(!list[i].tendername){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].tendername+"</td>";
          }
          if(!list[i].packagename){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].packagename+"</td>";
          }
          if(!list[i].quote){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].quote+"</td>";
          }
          if(!list[i].technicalpoints){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].technicalpoints+"</td>";
          }
          if(!list[i].businesspoints){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].businesspoints+"</td>";
          }
          if(!list[i].pricepoints){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].pricepoints+"</td>";
          }
          if(!list[i].totalpoints){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].totalpoints+"</td>";
          }
          if(!list[i].tenderOrder){ // 排名
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].tenderOrder+"</td>";
          }
          if(!list[i].remark){ // "",null,undefined,NaN
            html += "<td></td>";
          }else{
            html += "<td>"+list[i].remark+"</td>";
          }

          html += "<td style=\"white-space:normal;word-break:break-all;text-align:left;\"></td>\n" +
                  "                            </tr>";

        }

      }else{
        if(list[0].resultcontent == '0001'){//投标人排名
          html += "                        <table id=\"bidtable\" border=\"1\" width=\"600px\" cellspacing=\"0\" cellpadding=\"0\" style=\"'border:1x solid #e0e0e0;'\">\n" +
                  "                            <tbody><tr>\n" +
                  "                                <td align=\"center\" style=\"word-break:nowrap\">投标人</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">标段</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">排名</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">备注</td>\n" +
                  "                            </tr>";
          for(var i = 0; i < list.length; i++){
            html += "<tr align=\"center\">";
            if(!list[i].tendername){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].tendername+"</td>";
            }
            if(!list[i].packagename){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].packagename+"</td>";
            }
            if(!list[i].tenderOrder){ // 排名
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].tenderOrder+"</td>";
            }
            if(!list[i].remark){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].remark+"</td>";
            }

            html += "<td style=\"white-space:normal;word-break:break-all;text-align:left;\"></td>\n" +
                    "                            </tr>";

          }
        }else if(list[0].resultcontent == '0002'){//投标人排名及报价
          html += "                        <table id=\"bidtable\" border=\"1\" width=\"600px\" cellspacing=\"0\" cellpadding=\"0\" style=\"'border:1x solid #e0e0e0;'\">\n" +
                  "                            <tbody><tr>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">投标人</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">标段</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">标段报价(元)</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">排名</td>\n" +
                  "                                <td align=\"center\" style=\"white-space:nowrap\">备注</td>\n" +
                  "                            </tr>";
          for(var i = 0; i < list.length; i++){
            html += "<tr align=\"center\">";
            if(!list[i].tendername){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].tendername+"</td>";
            }
            if(!list[i].packagename){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].packagename+"</td>";
            }
            if(!list[i].quote){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].quote+"</td>";
            }
            if(!list[i].tenderOrder){ // 排名
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].tenderOrder+"</td>";
            }
            if(!list[i].remark){ // "",null,undefined,NaN
              html += "<td></td>";
            }else{
              html += "<td>"+list[i].remark+"</td>";
            }

            html += "<td style=\"white-space:normal;word-break:break-all;text-align:left;\"></td>\n" +
                    "                            </tr>";

          }
        }
      }
      html += "</tbody></table>\n" +
              "                    </td>\n" +
              "                </tr>";
      html += "<tr>\n" +
              "                    <td class=\"col\">联系人：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].assignedusername){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].assignedusername + "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">电话：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].resultcontactphone){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].resultcontactphone + "</td>\n" +
                "                </tr>";
      }
      html += "<tr>\n" +
              "                    <td class=\"col\">公示日期：</td>\n" +
              "                    <td class=\"col1\">";
      if(!list[0].publicitydatestart && !list[0].publicitydateend){ // "",null,undefined,NaN
        html +=  "</td>\n" +
                "                </tr>";

      }else{
        html += list[0].publicitydatestart+" 至 " +list[0].publicitydateend+"</td>\n" +
                "                </tr>";
      }
      let title = "<div class=\"column_block_con_title\">" +
              "                            <h3>"+list[0].projectname+"</h3>" ;
      if(list[0].lastmodifydate){
        title = title + "                            <span>发布时间："+list[0].lastmodifydate+"</span>";
      }else{
        title = title + "                            <span>发布时间：</span>";
      }
      title = title +"                        </div>";
      let content = title + "<div>"+html+"</div>";
      return content;
    }
  }
};
</script>

<style lang="less" scoped>
  .invitation-fbid-check-container {
    // padding-top: 45px;

    .header {
      padding: 1rem 0.83333rem;
      border-bottom: 1px solid #dddddd;
      background: #fff; }
    .header ul .list-view .list-view-title {
      font-size: 1rem;
      color: #212121;
      text-align: center; }
    .header ul .list-view .list-view-title strong {
      font-weight: 500;
      line-height: 1.55556rem; }
    .header ul .list-view .list-view-info {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      padding-top: 0.72222rem;
      .list-view-info-type{
        // padding-left: 1rem;
        text-align: center;
      }
      .list-view-info-time{
         white-space: nowrap;
          text-align: center;
      }
      .list-view-info-area{
        // text-align: center;
        // white-space: normal;
        
      }
    }
    .header ul .list-view .list-view-info .icon {
      width: 15px;
      vertical-align: middle;
    }
    .header ul .list-view .list-view-info .list-view-info-type, .header ul .list-view .list-view-info .list-view-info-area, .header ul .list-view .list-view-info .list-view-info-time {
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 22%;
      -ms-flex: 0 0 22%;
      flex: 0 0 30%;
      width: 25%;
      // overflow: hidden;
     
       }
    .header ul .list-view .list-view-info .list-view-info-time {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1; }
    .header ul .list-view .list-view-info span {
      font-size: 0.72222rem;
      color: #acacac; }

    .cf:before, .cf:after {
      display: table;
      content: ""; }

    .cf:after {
      clear: both; }

    .cf {
      zoom: 1;
      clear: both; }
    .banner {
      // width: 100%;
      position: relative;
      // background: -webkit-linear-gradient(to right, #58baff, #169dff);
      // background: -webkit-linear-gradient(left, #58baff, #169dff);
      background: linear-gradient(to right, #58baff, #169dff);
      padding: 0.72222rem 0.83333rem;
       }
    .banner span {
      color: #fff;
      font-size: 0.77778rem; }
    .banner .btn {
      width: 4.8rem;
      font-size: 0.66667rem;
      padding: 0.38889rem 0.5rem;
      border: 1px solid #fff;
      border-radius: 10px;
      // margin-left: 14vw; 
      position:absolute;
      top: -0.85rem;
      // left: 1rem;
      right: 1rem;
      white-space: nowrap;
      }
    .banner .btn img{
      width: 12px;
      vertical-align: middle;
      margin-right: 1vw;
    }
    // .banner .guanzhu {
    //   position: absolute;
    //   display: block;
    //   width: 6.66667rem;
    //   height: 3.33333rem;
    //   right: 0;
    //   top: -10px;
    //   z-index: 9999;
    // }

    .van-overlay{
      z-index: 12!important;
      .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        img{
          position: absolute;
          top: 0;
          height: 100%;
        }
        .know{
          top: 160px;
          position: absolute;
          width: 150px;
          height: 50px;
          right: 60px;
        }
        .iosKnow{
          width: 100%;
          height: 100%;
        }
      }
    }

    .project-content, u, span {
      // width: 100%;
      font-size: 13px;
      color: #737373;
      word-break: break-word;
      width: calc(100% - 40px);
      margin: 20px auto;
    }

    .project-content p strong span {
      color: #545454;
    }

    .detail-info {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-top: 1px dashed #aaa;
      border-bottom: 1px dashed #aaa;
      .desc-area {
        color: #b0b2b1;
        font-size: 12px;
        text-align: center;
        span {
          color: #e58951;
          font-size: 13px;
          font-weight: 500;
        }
      }
      .clicks, .updateDate, .city {
        display: block;
      }
    }
  }
</style>